export { default } from './CompanyLogo';
